import { generateId } from "../../App.utils";
import { generatePlayerName } from "../../playerUtils";
import { useLocalStorageState } from "./useLocalStorageState";
import { usePlayerPresence } from "./usePlayerPresence";

const PLAYER_STORAGE_KEY = "currentPlayer";

function createCurrentPlayer() {
  return {
    name: generatePlayerName(),
    isSpymaster: false,
    active: true,
    playerId: generateId(),
  };
}

function normalizeCurrentPlayer(player) {
  const basePlayer = createCurrentPlayer();

  return {
    ...basePlayer,
    ...player,
    active: true,
    isSpymaster: false,
    playerId: player?.playerId || basePlayer.playerId,
  };
}

export function useCurrentPlayer() {
  const [currentPlayer, setCurrentPlayer] = useLocalStorageState(
    PLAYER_STORAGE_KEY,
    createCurrentPlayer,
    normalizeCurrentPlayer,
  );

  usePlayerPresence(setCurrentPlayer);

  return [currentPlayer, setCurrentPlayer];
}
